<style scoped>
  .my-aside {
    min-width: 290px;
    padding: 40px 30px;
    margin-right: 10px;
    font-family: PingFang-SC-Bold;
    background-color: #fff;
    box-sizing: border-box;
  }

  li {
    margin-bottom: 20px;
    list-style: none;
  }

  h5 {
    font-size: 16px;
    color: #333333;
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
    margin-bottom: 10px;
    color: #666666;
  }

  a {
    text-decoration: none;
  }

  .router-link-exact-active h5 {
    color: #2F70D4;
  }
</style>

<template>
  <ul class="my-aside">
    <li v-for="(item, index) in arr" v-bind:key="index">
      <router-link v-bind:to="item.to">
        <h5>{{ item.title }}</h5>
        <!-- <p>{{ item.desc }}</p> -->
      </router-link>
    </li>
  </ul>
</template>

<script>
  const arr = [
    {
      title: '采编一体化',
      desc: '采编一体化描述',
      to: '/ProductCiaabian'
    },
    {
      title: '田田阅读',
      desc: '田田阅读描述',
      to: '/ProductTiantian'
    },
    {
      title: '云田购',
      desc: '云采购描述',
      to: '/ProductYun'
    },
    {
      title: '智慧图书馆',
      desc: '智慧图书馆描述',
      to: '/ProductZhihui'
    },
    {
      title: '图书馆服务',
      desc: '图书馆服务描述',
      to: '/ProductFuwu'
    },
    {
      title: '图书馆消毒柜',
      desc: '图书馆消毒柜描述',
      to: '/ProductXiaodugui'
    },
    {
      title: 'AI体温检测系统',
      desc: 'AI体温检测系统描述',
      to: '/ProductAI'
    },
    // {
    //   title: '期刊订购',
    //   desc: 'AI体温检测系统描述',
    //   to: '/ProductQiKan'
    // },
    {
      title: '消毒机器人',
      desc: '消毒防疫机器人',
      to: '/DsfRobot'
    },
    {
      title: '馆藏分析平台',
      desc: '馆藏分析平台系统描述',
      to: '/ProductGuancang'
    }
  ]
  export default {
    name: 'MyAside',
    data() {
      return {
        arr
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MyAside.vue